// Release B-Fidelity-2c · Slice I — Training Mode persistent banner.
// Renders across every screen while /api/auth/me returns training_session=true.
import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TrainingModeBanner() {
  const [flags, setFlags] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const r = await axios.get(`${API}/auth/me`, { withCredentials: true });
        if (!cancelled) setFlags(r.data);
      } catch { /* not logged in — banner stays hidden */ }
    }
    load();
    const t = setInterval(load, 60_000);  // re-check hourly on long sessions
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (!flags?.training_session) return null;

  return (
    <div data-testid="training-mode-banner"
         role="alert"
         style={{
           position: "sticky", top: 0, zIndex: 60,
           background: "#facc15", color: "#111827",
           padding: "10px 20px", textAlign: "center",
           fontWeight: 800, letterSpacing: 0.4, fontSize: 13,
           borderBottom: "3px solid #a16207",
           fontFamily: "'Space Mono', monospace", textTransform: "uppercase",
         }}>
      Training Mode — This information is for practice only ·
      Tenant: {flags.tenant_display_name || "Training Mode"}
    </div>
  );
}


export function TrainingRecordBadge({ kind = "practice" }) {
  const label = {
    tutorial_example: "Tutorial Example",
    practice_record: "Practice Record",
    simulated_request: "Simulated Request",
    demonstration_project: "Demonstration Project",
    training_only_data: "Training-Only Data",
    practice: "Practice Record",
  }[kind] || "Training-Only Data";
  return (
    <span data-testid={`training-badge-${kind}`}
          style={{
            display: "inline-block", padding: "2px 8px", borderRadius: 9999,
            background: "#facc1522", color: "#a16207", fontSize: 10,
            fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase",
            border: "1px solid #a1620755", marginLeft: 6,
          }}>
      {label}
    </span>
  );
}
